
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Images Directory`}</h1>
    <p>{`You can add images in this folder, and reference them using`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import img from 'images/bild.jpg'

//...

<img src={img} />
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;